// extracted by mini-css-extract-plugin
export default {"image":"L5-z","loaded":"M5-z"};